// extracted by mini-css-extract-plugin
export default {"image-wrapper":"ProfileImgBtn_image-wrapper__2DTqb","avatar":"ProfileImgBtn_avatar__xxR7K","btn":"ProfileImgBtn_btn__-ijV4","i":"ProfileImgBtn_i__F1zae"};